import { createFileRoute } from "@tanstack/react-router";
import { EmployeeScheduleView } from "@/components/employee/EmployeeScheduleView";

export const Route = createFileRoute("/_authenticated/employee/")({
  head: () => ({ meta: [{ title: "Schedule — Staff" }] }),
  component: EmployeeSchedulePage,
});

function EmployeeSchedulePage() {
  return <EmployeeScheduleView />;
}
